import React from 'react'
import { ShippingFeesInterface } from 'common/types/entities/ShippingFeesInterface'
import TextFontUpdater from 'client/components/core/Sidebar/components/Settings/components/Font/TextFontUpdater'
import {
  useUpdateEntity,
  useUpdateProp,
} from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import DeviceAppearanceNew from 'client/components/core/Sidebar/components/Settings/options/DeviceAppearance/DeviceAppearanceNew'
import HtmlAttrId from 'client/components/core/Sidebar/components/Settings/options/HtmlAttrId'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import {
  FontSize,
  LineHeight,
} from 'client/components/core/Sidebar/components/Settings/styles'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'

interface ShippingFeesSettingsProps {
  entity: ShippingFeesInterface
}

const ShippingFeesSettings = ({ entity }: ShippingFeesSettingsProps) => {
  const { isMobile } = useDeviceModeContext()
  const updateProp = useUpdateProp(entity)
  const updateEntity = useUpdateEntity<ShippingFeesInterface>()

  return (
    <div>
      <GroupTitle isFirst>typography</GroupTitle>
      <FontSize
        update={updateProp('fontSize')}
        mobileUpdate={updateProp('mobileFontSize')}
        fontSize={entity.fontSize}
        mobileFontSize={entity.mobileFontSize}
      />
      <LineHeight
        lineHeight={entity.lineHeight}
        mobileLineHeight={entity.mobileLineHeight}
        update={updateProp('lineHeight')}
        mobileUpdate={updateProp('mobileLineHeight')}
        fontSize={entity.fontSize}
        mobileFontSize={entity.mobileFontSize}
      />
      <TextFontUpdater entity={entity} update={updateEntity} />
      <SizeAndPositionGroup
        padding={isMobile ? entity?.mobilePadding : entity.padding}
        updatePadding={updateProp(isMobile ? 'mobilePadding' : 'padding')}
        margin={isMobile ? entity.mobileMargin : entity.margin}
        updateMargin={updateProp(isMobile ? 'mobileMargin' : 'margin')}
      />
      <DeviceAppearanceNew entity={entity} />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </div>
  )
}

export default ShippingFeesSettings
